import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import JobService from "../../Controller/JobController";
import ProjectMemberService from "../../../Setup/controller/ProjectMemberController/ProjectMemberController";

function CreateJobEngineerMobile({
    JobID,
    EngineerData = null,
    onSaved,
    handleBack,
    isClosed = 0
}) {

    const navigate = useNavigate();
    const ProjectID = localStorage.getItem('ProjectID');
    const UserID = localStorage.getItem('UserID');
    const formatDate = (dateStr) => {
        // Convert YYYY/MM/DD to YYYY-MM-DD
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    const parseDate = (dateStr) => {
        // Convert YYYY-MM-DD to YYYY/MM/DD
        return dateStr ? dateStr.replace(/-/g, '/') : '';
    };

    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getCurrentTime = () => {
        const now = new Date();
        return now.toTimeString().split(' ')[0].slice(0, 5);
    };

    const getOneHourLaterTime = () => {
        const now = new Date();
        now.setHours(now.getHours() + 1);
        return now.toTimeString().split(' ')[0].slice(0, 5);
    };
    const emptyData = {
        EngineerTimeID: 0,
        IsTimeSepcified: '0',
        PayRateID: 'BASC',
        DepartBaseDate: '',
        DepartBaseTime: '',
        ReturnBaseDate: '',
        ReturnBaseTime: '',
        StartDate: getCurrentDate(),
        StartTime: getCurrentTime(),
        EndDate: getCurrentDate(),
        EndTime: getOneHourLaterTime(),
        HoursTravel: '0',
        HoursDate: '1',
        UserID: UserID,
        IssueID: JobID
    };

    const [formData, setFormData] = useState(emptyData);
    const [projectMemberList, setProjectMemberList] = useState([]);

    useEffect(() => {
        fetchProjectMember();
    }, []);

    useEffect(() => {
        if (EngineerData) {
            debugger;
            const hasDepartBaseDate = EngineerData.DepartBaseDate && EngineerData.DepartBaseDate.trim() !== '';
            setFormData({
                EngineerTimeID: EngineerData.EngineerTimeID,
                IsTimeSepcified: hasDepartBaseDate ? '1' : '0',
                PayRateID: EngineerData.PayRateID || 'BASC',
                DepartBaseDate: formatDateForInput(EngineerData.DepartBaseDate) || '',
                DepartBaseTime: EngineerData.DepartBaseTime || '',
                ReturnBaseDate: formatDateForInput(EngineerData.ReturnBaseDate) || '',
                ReturnBaseTime: EngineerData.ReturnBaseTime || '',
                StartDate: formatDateForInput(EngineerData.StartDate) || getCurrentDate(),
                StartTime: EngineerData.StartTime || getCurrentTime(),
                EndDate: formatDateForInput(EngineerData.EndDate) || getCurrentDate(),
                EndTime: EngineerData.EndTime || getOneHourLaterTime(),
                HoursTravel: EngineerData.HoursTravel || '0',
                HoursDate: EngineerData.HoursDate || '',
                Other: EngineerData.Other || '',
                UserID: EngineerData.UserID,
                IssueID: JobID
            });
        }
        else {
            setFormData({
                EngineerTimeID: '0',
                IsTimeSepcified: '0',
                PayRateID: 'BASC',
                DepartBaseDate: '',
                DepartBaseTime: '',
                ReturnBaseDate: '',
                ReturnBaseTime: '',
                StartDate: getCurrentDate(),
                StartTime: getCurrentTime(),
                EndDate: getCurrentDate(),
                EndTime: getOneHourLaterTime(),
                HoursTravel: '0',
                HoursDate: '1',
                Other: "",
                UserID: UserID,
                IssueID: JobID
            });
        }
    }, [EngineerData]);

    const fetchProjectMember = async () => {
        try {

            const redirectCallback = () => navigate("/");

            let list =
                await ProjectMemberService.GetAllProjectMembers(
                    ProjectID,
                    redirectCallback
                );
            list = list.filter(x => x.UserID.toString() === UserID.toString());
            setProjectMemberList(list);

        } catch (error) {
            console.error(error);
        }
    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : value
        }));
    };

    const handleSave = async () => {

        if (formData.UserID === 0) {
            Swal.fire(
                "Warning",
                "Please select an engineer.",
                "warning"
            );
            return;
        }

        try {

            const redirectCallback = () => navigate("/");

            const data = {
                JobID,
                ...formData
            };

            const response = await JobService.CreateEngineerTime(data);

            Swal.fire({
                icon: "success",
                title: "Saved Successfully",
                timer: 1200,
                showConfirmButton: false
            });

            if (onSaved)
                onSaved();

            if (handleBack)
                handleBack();

        } catch (error) {

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to save engineer."
            });

        }

    };
    const handleRadio1Change = (e) => {
        setFormData(prev => ({
            ...prev,
            PayRateID: e.target.value
        }));
    };

    const handleCheckboxChange = (e) => {
        setFormData(prev => ({
            ...prev,
            Other: e.target.checked
        }));
    };
    const formatDateForInput = (dateStr) => {
        if (!dateStr) return "";

        // Remove time portion if present
        dateStr = dateStr.split(" ")[0];

        // Already in YYYY-MM-DD
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr))
            return dateStr;

        // YYYY/MM/DD
        if (/^\d{4}\/\d{2}\/\d{2}$/.test(dateStr))
            return dateStr.replace(/\//g, "-");

        // DD/MM/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
            const [dd, mm, yyyy] = dateStr.split("/");
            return `${yyyy}-${mm}-${dd}`;
        }

        // Last fallback
        const d = new Date(dateStr);
        if (!isNaN(d.getTime())) {
            return d.toISOString().split("T")[0];
        }

        return "";
    };
    useEffect(() => {
        const calculateHoursTravel = () => {
            if (
                formData.DepartBaseDate && formData.DepartBaseTime &&
                formData.ReturnBaseDate && formData.ReturnBaseTime &&
                !isNaN(Date.parse(`${formatDate(formData.DepartBaseDate)}T${formData.DepartBaseTime}`)) &&
                !isNaN(Date.parse(`${formatDate(formData.ReturnBaseDate)}T${formData.ReturnBaseTime}`))
            ) {
                /*    const beginTravelDateTime = new Date(`${formatDate(formData.DepartBaseDate)}T${formData.DepartBaseTime}`);
                    const endTravelDateTime = new Date(`${formatDate(formData.ReturnBaseDate)}T${formData.ReturnBaseTime}`);
    
                    const diffInMilliseconds = Math.abs(endTravelDateTime - beginTravelDateTime);
                    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);
    
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursTravel: diffInHours.toFixed(2)
                    }));*/

                const beginTravelDateTime = new Date(`${formatDate(formData.DepartBaseDate)}T00:00:00`);
                const endTravelDateTime = new Date(`${formatDate(formData.ReturnBaseDate)}T00:00:00`);

                const diffInMillisecondss = Math.abs(endTravelDateTime - beginTravelDateTime);
                const diffInHourss = (diffInMillisecondss / (1000 * 60 * 60) / 24) + 1;


                const startTimeString = `${formatDate('2000/01/01')}T${formData.DepartBaseTime}`;
                const endTimeString = `${formatDate('2000/01/01')}T${formData.ReturnBaseTime}`;


                const startTime = new Date(startTimeString);
                const endTime = new Date(endTimeString);

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
                    console.error('Invalid date(s):', startTimeString, endTimeString);
                } else {
                    // Calculate the difference in milliseconds
                    const differenceInMs = endTime - startTime;

                    // Convert the difference from milliseconds to hours
                    const differenceInHours = differenceInMs / (1000 * 60 * 60);
                    const TotalHourse = diffInHourss * differenceInHours;
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursTravel: TotalHourse.toFixed(2)
                    }));
                }
            }
        };

        const calculateHoursDate = () => {
            if (
                formData.StartDate && formData.StartTime &&
                formData.EndDate && formData.EndTime &&
                !isNaN(Date.parse(`${formatDate(formData.StartDate)}T${formData.StartTime}`)) &&
                !isNaN(Date.parse(`${formatDate(formData.EndDate)}T${formData.EndTime}`))
            ) {


                const beginStartDateTime = new Date(`${formatDate(formData.StartDate)}T00:00:00`);
                const endDateTime = new Date(`${formatDate(formData.EndDate)}T00:00:00`);

                const diffInMillisecondss = Math.abs(endDateTime - beginStartDateTime);
                const diffInHourss = (diffInMillisecondss / (1000 * 60 * 60) / 24) + 1;


                const startTimeString = `${formatDate('2000/01/01')}T${formData.StartTime}`;
                const endTimeString = `${formatDate('2000/01/01')}T${formData.EndTime}`;


                const startTime = new Date(startTimeString);
                const endTime = new Date(endTimeString);

                if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
                    console.error('Invalid date(s):', startTimeString, endTimeString);
                } else {
                    // Calculate the difference in milliseconds
                    const differenceInMs = endTime - startTime;

                    // Convert the difference from milliseconds to hours
                    const differenceInHours = differenceInMs / (1000 * 60 * 60);
                    const TotalHourse = 1 * differenceInHours;
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        HoursDate: TotalHourse.toFixed(2)
                    }));
                }
            }
        };

        calculateHoursTravel();
        calculateHoursDate();
    }, [
        formData.DepartBaseDate, formData.DepartBaseTime,
        formData.ReturnBaseDate, formData.ReturnBaseTime,
        formData.StartDate, formData.StartTime,
        formData.EndDate, formData.EndTime
    ]);
    return (

        <div className="container-fluid">

            <div className="card mt-2">

                <div className="card-body">

                    <div className="row">

                        <div className="col-6 mb-3">
                            <label>Begin Travel</label>

                            <input
                                type="date"
                                className="form-control"
                                name="DepartBaseDate"
                                value={formData.DepartBaseDate || ""}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-6 mb-3">

                            <label>Time</label>

                            <input
                                type="time"
                                className="form-control"
                                name="DepartBaseTime"
                                value={formData.DepartBaseTime || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Return Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="ReturnBaseDate"
                                value={formData.ReturnBaseDate || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Time</label>

                            <input
                                type="time"
                                className="form-control"
                                name="ReturnBaseTime"
                                value={formData.ReturnBaseTime || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-12 mb-3">

                            <label>Travel Hours</label>

                            <input
                                className="form-control"
                                name="HoursTravel"
                                value={formData.HoursTravel}
                                onChange={handleChange}
                                readOnly="true"
                            />

                        </div>



                        <div className="col-6 mb-3">

                            <label>Start Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="StartDate"
                                value={formData.StartDate || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Start Time</label>

                            <input
                                type="time"
                                className="form-control"
                                name="StartTime"
                                value={formData.StartTime || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Finish Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="EndDate"
                                value={formData.EndDate || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Finish Time</label>

                            <input
                                type="time"
                                className="form-control"
                                name="EndTime"
                                value={formData.EndTime || ""}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-6 mb-3">

                            <label>Job Hours</label>

                            <input
                                className="form-control"
                                name="HoursDate"
                                value={formData.HoursDate}
                                onChange={handleChange}
                                readOnly="true"
                            />

                        </div>

                        <div className="d-flex align-items-center justify-content-between flex-wrap mb-3">

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="PayRateID"
                                    value="BASC"
                                    checked={formData.PayRateID === "BASC"}
                                    onChange={handleRadio1Change}
                                />
                                <label className="form-check-label ms-1" style={{ marginLeft: "20px" }}>Basic</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="PayRateID"
                                    value="OVRT"
                                    checked={formData.PayRateID === "OVRT"}
                                    onChange={handleRadio1Change}
                                />
                                <label className="form-check-label ms-1" style={{ marginLeft: "20px" }}>Overtime</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="PayRateID"
                                    value="DBLT"
                                    checked={formData.PayRateID === "DBLT"}
                                    onChange={handleRadio1Change}
                                />
                                <label className="form-check-label ms-1" style={{ marginLeft: "20px" }}>Double Time</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="Other"
                                    checked={formData.Other}
                                    onChange={handleCheckboxChange}
                                />
                                <label className="form-check-label ms-1" style={{ marginLeft: "20px" }}>Other</label>
                            </div>

                        </div>

                    </div>

                    <div className="d-grid mt-3">

                        <button
                            className="btn btn-primary"
                            onClick={handleSave}
                        >
                            {formData.EngineerTimeID > 0
                                ? "Update"
                                : "Save"}
                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default CreateJobEngineerMobile;